/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () =>
    import(/* webpackChunkName: '' */ `./components/${path}`).then(
        m => m.default || m
    );

export const routes = [
    {
        path: "/configuracion/unidades",
        name: "Unidades",
        component: page("UnitList")
    },
    {
        path: "/configuracion/unidades/:id",
        name: "Ver Unit",
        component: page("UnitView"),
        hidden: true
    }
];
